module.exports = __webpack_public_path__ + "e37a4a6c516c344cec5adeb8e99cb39b.MP3";